import React from "react";
import { LogEvent } from "../models/LogEvents";
import { TwilioDetailsDialog } from "./TwilioLogDetails/TwilioDetailsDialog";
import { LogListContainer } from "./LogListContainer";
import queryString from "query-string";
import { getUrlWithoutQuery } from "../utils";
import { MessageCard } from "./MessageCard";
import { GetConferenceTrackingRecordsResponse } from "../models/TwilioModels";

interface TwilioDetailsLogListContainerProps {
	//A list of LogEvent type objects used to create the EventCards.
	logs: LogEvent[];
	//id of subscription
	subscriptionId: string;
	//Sid for account to get details for
	accountSid: string;
	//Id of product
	productId: string;
	//name of page to open details dialog from
	pageName: string;
	//Callback method to be called when message not included with log and must be retreived via a seperate API call.
	loadJson?: (sid: string) => () => Promise<any>;
}

const sidStack: string[] = [];

/**
 * Accepts a list of LogEvents that will be made
 * into EventCards with the option to pop up a details dialogue upon clicking callsid
 * @param data
 */
export const TwilioDetailsLogListContainer = (data: TwilioDetailsLogListContainerProps) => {
	const query = queryString.parse(window.location.search);

	//These variables are used to manage the opening of the TwilioDetails component
	const [detailsOpen, setOpen] = React.useState(query.__sid !== undefined || false);
	const [detailsSid, setSid] = React.useState(String(query.__sid || ""));
	const [detailsAccountSid] = React.useState(String(query.__accountSid || data.accountSid));
	const [detailsConferenceData, setConference] = React.useState<GetConferenceTrackingRecordsResponse[]>([]);
	const [canGoBack, setCanGoBack] = React.useState(false);
	const renderDetails = (sid: string, open: boolean) => {
		const newUrl = getUrlWithoutQuery() + `?__accountSid=${data.accountSid}&__sid=${sid}`;
		setSid(sid);
		setOpen(open);
		return newUrl;
	};
	const closeDetails = (open) => {
		window.history.pushState({}, "", getUrlWithoutQuery());
		setOpen(open);
		while (sidStack.length > 0) {
			sidStack.pop();
		}
		setConference([]);
		setCanGoBack(false);
	};

	const navigateToNewConferenceSid = (newSid: string, oldSid: string) => {
		sidStack.push(oldSid);
		setCanGoBack(true);
		window.history.pushState({}, "", renderDetails(newSid, true));
	};

	const generateNewTabUrl = (sid: string) => {
		return getUrlWithoutQuery() + `?__accountSid=${data.accountSid}&__sid=${sid}`;
	};

	const navigateToLastConferenceSid = () => {
		window.history.pushState({}, "", renderDetails(sidStack.pop()!, true));
		setCanGoBack(sidStack.length != 0);
	};

	const setConferenceData = (conferenceData: GetConferenceTrackingRecordsResponse[]) => {
		setConference(conferenceData);
	};

	function renderDetailsPage() {
		if (detailsOpen) {
			return (
				<TwilioDetailsDialog
					data-testid={"details-dialog"}
					productId={data.productId}
					subscriptionId={data.subscriptionId}
					accountSid={detailsAccountSid}
					sid={detailsSid}
					setOpen={closeDetails}
					detailsOpen={detailsOpen}
					setConferenceData={setConferenceData}
					conferenceData={detailsConferenceData}
					navigateToNewConferenceSid={navigateToNewConferenceSid}
					navigateToLastConferenceSid={navigateToLastConferenceSid}
					generateNewTabUrl={generateNewTabUrl}
					canGoBack={canGoBack}
				></TwilioDetailsDialog>
			);
		}
	}
	return (
		<div>
			{renderDetailsPage()}
			{data.logs.length > 0 ? (
				<LogListContainer
					data-testid="test-details-log-list-container"
					loadJson={data.loadJson}
					logs={data.logs}
					renderDetailsFunction={renderDetails}
				></LogListContainer>
			) : (
				<MessageCard message="No Events found." />
			)}
		</div>
	);
};
